import { CodReconcileApiRepository } from "@/app/infrastructures/repositories/api/CodReconcileApiRepository";
import {
  GetCourierNotes,
  SubmitCourierNotes,
  SubmitCourierNotesPhotos,
  TaskSettlementCourierParams
} from "@/data/payload/api/CodReconcileApiRequest";
import {
  CourierDetail,
  CodDashboardDetailCourier,
  CourierDetailApiRequest,
  CourierDetailList,
  CourierDetailPendingReconcile,
  CourierSummary,
  DashboardDeliveryCourierDetail,
  CourierNotes,
  CourierHistory,
  TaskSetllementCourier
} from "@/domain/entities/CodReconcile";
import { injectable } from "tsyringe";

@injectable()
export class CodReconcilePresenter {
  private repository: CodReconcileApiRepository;

  constructor(repo: CodReconcileApiRepository) {
    this.repository = repo;
  }

  async getCourierDetailSummary(
    params: CourierDetailApiRequest
  ): Promise<CodDashboardDetailCourier> {
    return this.repository.getCourierDetailSummary(params);
  }

  getCourierSummaryDetailV2(
    params: CourierDetailApiRequest,
    version: string
  ): Promise<CourierSummary> {
    return this.repository.getCourierSummaryDetailV2(params, version);
  }

  getCourierDetail(
    params: CourierDetailApiRequest,
    version: string
  ): Promise<CourierDetailList> {
    return this.repository.getCourierDetail(params, version);
  }

  getCourierDetailV2(
    params: CourierDetailApiRequest,
    version: string
  ): Promise<CourierDetail[]> {
    return this.repository.getCourierDetailV2(params, version);
  }

  getDetailCourierPendingReconcile(
    params: CourierDetailApiRequest,
    version: string
  ): Promise<CourierDetailPendingReconcile[]> {
    return this.repository.getDetailCourierPendingReconcile(params, version);
  }

  getDashboardDeliveryCourierDetail(
    phone: string
  ): Promise<DashboardDeliveryCourierDetail> {
    return this.repository.getDashboardDeliveryCourierDetail(phone);
  }

  getCourierNotes(payload: GetCourierNotes): Promise<CourierNotes> {
    return this.repository.getCourierNotes(payload);
  }

  getCourierHistory(payload: GetCourierNotes): Promise<CourierHistory[]> {
    return this.repository.getCourierHistory(payload);
  }

  uploadCourierNotesPhotos(
    payload: SubmitCourierNotesPhotos
  ): Promise<boolean> {
    return this.repository.uploadCourierNotesPhotos(payload);
  }

  submitCourierNotes(payload: SubmitCourierNotes): Promise<boolean> {
    return this.repository.submitCourierNotes(payload);
  }

  getTaskSettlementCourier(
    params: TaskSettlementCourierParams
  ): Promise<TaskSetllementCourier[]> {
    return this.repository.getTaskSettlementCourier(params);
  }

  getTaskSettlementCourierDetail(id: number): Promise<TaskSetllementCourier> {
    return this.repository.getTaskSettlementCourierDetail(id);
  }
}
